export default "__VITE_ASSET__5PPqD1Lr__"